import React, { useEffect, useState } from "react";
import usePasses from "./hooks/useMixedTicket";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import useFacility from "../../../utils/hooks/useFacility";
import PassesColorPage from "../LimitedTicket/PassesColorPage";

const MixedTicket: React.FC = () => {
  const { requestGetAssortGroups, passes } = usePasses();
  const facilityIds = useFacility();
  const [openModal, setOpenModal] = useState(true);
  const handleOpenPassModal = () => {
    setOpenModal(!openModal);
  };

  const [passIndex, setPassIndex] = useState(99);
  const handlePassIndex = (index: number) => {
    setPassIndex(index);
  };

  useEffect(() => {
    if (Boolean(facilityIds)) {
      requestGetAssortGroups();
    }
  }, [facilityIds]);


  return (
    <React.Fragment>
      <div>
        <PassesColorPage/>
          </div>
    </React.Fragment>
  );
};

export default MixedTicket;
